import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };
type State = { error: string | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error: error.message };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Dashboard render error:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex h-screen items-center justify-center bg-page p-8">
          <div className="max-w-lg rounded-lg border border-border-subtle bg-card p-6">
            <h1 className="mb-2 font-semibold text-text-primary">Dashboard error</h1>
            <p className="text-text-secondary" style={{ fontSize: "var(--font-body)" }}>
              {this.state.error}
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
